<template>
    <v-dialog v-model="historyDlg" width="800px" persistent>
        <v-form data-vv-name="historyForm">
            <v-card>
                <div class="headline dialog-header">
                    <v-toolbar color="primary" dark>
                        <v-toolbar-title style="padding-left: 10px">
                            Lịch sử
                        </v-toolbar-title>
                    </v-toolbar>
                    <v-btn
                            @click="historyDlg=false"
                            icon
                            style="position: absolute; right: 10px; top: 10px; color: #fff"
                    >
                        <v-icon>cancel</v-icon>
                    </v-btn>
                </div>
                <v-card-text>
                    <table class="lstTable" v-if="lstHistory.length>0">
                        <tr>
                            <th width="20%">Thời gian</th>
                            <th width="15%">Người xử lý</th>
                            <th width="15%">Xử lý</th>
                        </tr>
                        <tr v-for="item in lstHistory">
                            <td>{{item.createdAt|formatDateTime}}</td>
                            <td><label style="font-weight: bold;color:blue">{{item.userName}}</label></td>
                            <td>{{item.description}}</td>
                        </tr>
                    </table>
                    <div v-else style="border:1px solid grey;border-radius: 10px;padding: 10px">Không có lịch sử
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer/>
                    <v-btn @click="historyDlg=false">{{$t('lang.common.close')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-dialog>
</template>

<script>
    import axios from "axios";

    export default {
        name: 'feature-log',
        components: {},
        data: () => {
            return {
                formName: "lang.userlog.title",
                lstHistory: [],
                historyDlg: false,
            }
        },

        methods: {
            onSearch(feature, objectId) {
                let item = {
                    'feature': feature,
                    'objectId': objectId,
                    'status': 1
                }
                axios.post(process.env.VUE_APP_API_URL + "/userLog/search?page=-1&pageSize=-1", item).then(
                    data => {
                        this.lstHistory = data.items;
                    }
                )
                this.historyDlg = true;
            }
        }
    }
</script>
